import React from "react";
import { SurveyInput } from "pages/symptoms/surveyForms/surveyInput";
import {
  SurveyQuestionCard,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface OtherSectionProps {
  readonly currentPage: number;
  setOtherInput(input: string): void;
  readonly otherInput: string;
}

export const OtherSection: React.FC<OtherSectionProps> = ({
  currentPage,
  otherInput,
  setOtherInput
}) => {
  return (
    <>
      {currentPage === 16 && (
        <SurveyQuestionCard
          sectionTag="Other"
          title="Any other Symptoms"
          required
        >
          <FormItemStyle
            name="Any other symptoms"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <SurveyInput
              value={otherInput}
              placeholder={"Your Answer"}
              onChange={e => {
                setOtherInput(e.target.value);
              }}
              style={{ width: "100%" }}
            />
          </FormItemStyle>
        </SurveyQuestionCard>
      )}
    </>
  );
};
